export class ErrorUtils {
    static ifSuccess<T, R>(dados: T, cb: (dados: Exclude<T, Error>) => R, nullObject?: R): R {
        if (dados instanceof Error) {
            console.error(dados);
            return nullObject;
        }
        return cb && cb(dados as Exclude<T, Error>);
    }
}